import { render, staticRenderFns } from "./TranslationCard.vue?vue&type=template&id=46a0b589&scoped=true"
import script from "./TranslationCard.vue?vue&type=script&lang=js"
export * from "./TranslationCard.vue?vue&type=script&lang=js"
import style0 from "./TranslationCard.vue?vue&type=style&index=0&id=46a0b589&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46a0b589",
  null
  
)

export default component.exports